export var sumSubErrors = {
    forbiddenDocument: 'Unsupported or unacceptable type/country of document.',
    differentDocTypeOrCountry: 'Document type or country mismatches ones that was sent with metadata and the recognized type is forbidden by settings.',
    missingImportantInfo: 'Not all required document data can be recognized.',
    dataNotReadable: 'There is no available data to recognize from image.',
    expiredDoc: 'Document validity date is expired.',
    documentWayTooMuchOutside: 'Some parts of the document are cropped.',
    noIdDocFacePhoto: 'Face is not clearly visible on the document.',
    selfieFaceBadQuality: 'Face is not clearly visible on the selfie.',
    screenRecapture: 'Image might be a photo of screen.',
    screenshot: 'Image is a screenshot.',
    sameSides: 'Image of the same side of document was uploaded as front and back sides.',
    shouldBeMrzDocument: 'Sent document type should have an MRZ, but there is no readable MRZ on the image.',
    shouldBeDoubleSided: 'Two sides of the sent document should be presented.',
    shouldBeDoublePaged: 'The full double-page of the document (usually, two main passport pages) is required.',
    documentDeclinedBefore: 'The same image was uploaded and declined earlier in the same applicant.',
};
export var sumSubWarnings = {
    badSelfie: 'Make sure that your face and the photo in the document are clearly visible.',
    dataReadability: 'Please make sure that the information in the document is easy to read.',
    inconsistentDocument: 'Please ensure that all uploaded photos are of the same document.',
    maybeExpiredDoc: 'Your document appears to be expired.',
    documentTooMuchOutside: 'Please ensure that the document completely fits the photo.',
};
